export default __webpack_public_path__ + "static/media/IconUserHelp.6b19f4d5.svg";